import reduxFetch from 'react-redux-fetch';
import { createErrorMessage } from 'nallian-shared-ui/lib/lib/createErrorMessage';
import { addParametersToUri } from 'nallian-shared-ui/lib/lib/uri';
import { APP_SUBSCRIPTIONS_RESOURCE } from '../../constants';
import apiRoutes from '../../../../app/api/routes';

const AppSubscriptionsService = ComposedComponent =>
  reduxFetch([
    {
      resource: APP_SUBSCRIPTIONS_RESOURCE,
      method: 'get',
      request: (organisationId, t) => ({
        url: addParametersToUri(apiRoutes.organisationApps(), { organisationId }),
        meta: {
          toaster: {
            onErrorMessage: createErrorMessage(t, 'getAppSubscriptionsFailed'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default AppSubscriptionsService;
